import React from "react";

const HeaderArrow = () => {
  return (
    <svg fill="none" viewBox="0 0 1497 333">
      <path
        stroke="url(#paint0_linear_3203_231)"
        strokeOpacity=".05"
        strokeWidth="20"
        d="M5 108.243l40.92-22.41C88.08 63.42 169.92 18.598 253 11.127c83.08-7.47 164.92 22.411 248 82.174 83.08 59.764 164.92 149.408 248 194.231 83.08 44.822 164.92 44.822 248 7.47 83.08-37.352 164.92-112.056 248-134.467 83.08-22.411 164.92 7.47 207.08 22.411l40.92 14.941"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_3203_231"
          x1="749"
          x2="749"
          y1="10"
          y2="422"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".182" stopColor="#0D5FF9"></stop>
          <stop offset=".844" stopColor="#fff"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default HeaderArrow;
